mobileSize = 1050;

function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').appendTo('header');
  } else {
    $('#siteInfoBannerWidget').prependTo('.header-main .inner-container');
  }
}

$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1050) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1051) {
    $('body').removeClass('saffireMobileSize');
  }

  // Search
  $('.searchBoxInput input')
    .attr('value', 'Search')
    .attr('onclick', 'ClearDefaultText(this, "Search")');

  // General Message
  $('.generalmessage').prependTo('header');

  // Countdown
  placeCountdown();

  // Email Signup
  $('.homepage .emailSignup .emailSignupText').text('Don’t be left behind! Sign up today for the latest events and entertainment updates and get them delivered to your inbox!');
  $('.homepage .emailSignup .emailSubmitButton').appendTo('.emailInputField');
  $('.homepage .emailSignup .textbox')
    .attr('value', 'Email Address:')
    .attr('onclick', 'ClearDefaultText(this, "Email Address:")');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');

  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (!weatherBugSet && str != '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      var findSpace = str.lastIndexOf(' ');
      var stringLength = str.length;
      var res = str.substring(findSpace, stringLength);
      var start = str.substring(0, findSpace);
      $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
});

$(window).resize(function () {
  // Countdown
  placeCountdown();
});